import { AccessFlowAppModelV2 } from '@api';
import { Loader } from '@components';
import { RouterLink } from '@libs';
import { Stack, Typography, Button } from '@mui/material';

import { AccessFlowSelectionList } from './AccessFlowSelectionList';
import PermissionButton from '@common/components/PermissionButton';
import { Permission } from '@common/utils/admin_permissions';

interface AccessFlowSelectionContentProps {
  selectedScopeId: string;
  isFetched: boolean;
  filteredAccessFlows: AccessFlowAppModelV2[];
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  onClose: () => void;
  createNewFlowPath: string;
}

export function AccessFlowSelectionContent({
  selectedScopeId,
  isFetched,
  filteredAccessFlows,
  searchTerm,
  setSearchTerm,
  onClose,
  createNewFlowPath,
}: AccessFlowSelectionContentProps) {
  if (!isFetched) {
    return <Loader absolute={false} />;
  }

  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="subtitle2">Use the Access Scope in an existing Access Flow:</Typography>
      <AccessFlowSelectionList
        accessFlows={filteredAccessFlows}
        searchTerm={searchTerm}
        onSearchChange={(value) => setSearchTerm(value)}
        selectedScopeId={selectedScopeId}
      />
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <PermissionButton
          variant="contained"
          component={RouterLink}
          to={createNewFlowPath}
          permissions={[Permission.INVENTORY_WRITE]}
        >
          Use in New Access Flow
        </PermissionButton>
      </Stack>
    </Stack>
  );
}
